import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { DamageWaiverDTOBase } from "./DamageWaiverDTOBase";
import type { DamageWaiverTypeRef } from "./DamageWaiverTypeRef";
import type { DamageWaiverTypeStaff } from "./DamageWaiverTypeStaff";
import type { PersonStaff } from "./PersonStaff";
import type { PurchasableState } from "./PurchasableState";
import type { TrackedBase } from "./TrackedBase";
import type { WithPersonRefBase } from "./WithPersonRefBase";

export class DamageWaiverStaff implements DamageWaiverDTOBase, TrackedBase, WithPersonRefBase {
  constructor(public readonly personId: PersonStaff | null, public readonly waiverId: number, public readonly price: number | null, public readonly purchaseDate: Date | null, public readonly startDate: Date | null, public readonly expirationDate: Date | null, public readonly purchasableState: PurchasableState, public readonly voidCloseId: number | null, public readonly damageWaiverTypeId: DamageWaiverTypeStaff | null, public readonly createdOn: Date | null, public readonly createdBy: string | null, public readonly updatedOn: Date | null, public readonly updatedBy: string | null, public readonly damageWaiverTypeIdTargetIds: DamageWaiverTypeRef | null, public readonly optionName: string | null, public readonly optionDisplayName: string | null) {
    this.cbiServiceContext = null;
    this.personIdLoaded = this.personId != null;
    this.personIdCached = this.personId;
    this.damageWaiverTypeIdLoaded = this.damageWaiverTypeId != null;
    this.damageWaiverTypeIdCached = this.damageWaiverTypeId;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private personIdLoaded: boolean;
  private personIdCached: PersonStaff | null;
  private damageWaiverTypeIdLoaded: boolean;
  private damageWaiverTypeIdCached: DamageWaiverTypeStaff | null;
  async personIdLazy(): Promise<PersonStaff | null> {
    if (!this.personIdLoaded) {
      this.personIdCached = await this.cbiServiceContext!.damageWaiverService().getDamageWaiverStaffPersonId(this.waiverId);
      this.personIdLoaded = true;
    }
    return this.personIdCached;
  }
  async damageWaiverTypeIdLazy(): Promise<DamageWaiverTypeStaff | null> {
    if (!this.damageWaiverTypeIdLoaded) {
      this.damageWaiverTypeIdCached = await (this.damageWaiverTypeIdTargetIds != null ? this.cbiServiceContext!.damageWaiverService().getDamageWaiverTypeStaff(this.damageWaiverTypeIdTargetIds.assignId) : Promise.resolve(null));
      this.damageWaiverTypeIdLoaded = true;
    }
    return this.damageWaiverTypeIdCached;
  }
}
